import { CSSProperties } from "react";
import DateRangeIcon from "@mui/icons-material/DateRange";

interface DatePickerIconProps {
  hasLabel: boolean;
  onClick: () => void;
}

const DatePickerIcon = ({ hasLabel, onClick }: DatePickerIconProps) => {
  const style = { position: "absolute", top: hasLabel ? 33 : 7, right: 5 } as CSSProperties;
  return (
    <div style={style} onClick={onClick} className="cursor-pointer">
      <DateRangeIcon sx={{ color: "gray" }} />
    </div>
  );
};

export default DatePickerIcon;
